import React from 'react';
import { Outlet, useNavigate, NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { logoutUser } from '../../firebase/auth';
import Button from '../common/Button';
import './AdminLayout.css';

const AdminLayout = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logoutUser();
    navigate('/admin/login', { replace: true });
  };

  const navItems = [
    { path: '/admin/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/admin/messages', icon: '📧', label: 'Messages' },
    { path: '/admin/services', icon: '💼', label: 'Services' },
    { path: '/admin/testimonials', icon: '💬', label: 'Testimonials' },
    { path: '/admin/partners', icon: '🤝', label: 'Partners' },
    { path: '/admin/questions', icon: '📝', label: 'Trilogy Questions' },
    { path: '/admin/versions', icon: '📚', label: 'Version History' },
    { path: '/admin/audit-logs', icon: '📋', label: 'Audit Logs' },
    { path: '/admin/settings', icon: '⚙️', label: 'Settings' },
  ];

  return (
    <div className="admin-layout">
      {/* Admin Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-content">
          <div className="admin-logo" onClick={() => navigate('/admin')}>
            <h2>Admin Panel</h2>
          </div>

          <nav className="admin-nav">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}
                end={item.path === '/admin/dashboard' || item.path === '/admin'}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="admin-sidebar-footer">
            <div className="admin-user-info">
              <div className="user-avatar">👤</div>
              <div className="user-details">
                <p className="user-name">Admin</p>
                <p className="user-email">{user?.email}</p>
              </div>
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <span>🚪</span> Logout
            </button>
          </div>
        </div>
      </aside>

      {/* Admin Main Content */}
      <main className="admin-main">
        <div className="admin-content-wrapper">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
